import { useRef } from 'react'
import { Button, Icon, Input, type InputProps } from '@speaking-coach/ui'
import { cn } from '../components/ui/cn'

type DateFilterInputProps = Omit<InputProps, 'type' | 'value' | 'onChange'> & {
  label: string
  value: string
  onValueChange: (value: string) => void
}

/** A native date filter with the same one-click reset as entity pickers. */
export function DateFilterInput({ label, value, onValueChange, disabled, readOnly, className, ...props }: DateFilterInputProps): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null)
  const showClear = value !== '' && !disabled && !readOnly
  const clearLabel = `Clear ${label.toLowerCase()} filter`
  return (
    <div className="relative flex w-full items-center">
      <Input
        {...props}
        ref={inputRef}
        type="date"
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        onChange={(event) => onValueChange(event.target.value)}
        className={cn(showClear && '[&::-webkit-calendar-picker-indicator]:ml-8', className)}
      />
      {showClear && (
        <Button
          variant="ghost"
          size="iconSm"
          aria-label={clearLabel}
          title={clearLabel}
          className="absolute right-7 text-text-secondary hover:text-text-primary"
          onClick={() => {
            onValueChange('')
            inputRef.current?.focus()
          }}
        >
          <Icon name="clear" size={14} />
        </Button>
      )}
    </div>
  )
}
